import { render } from "./SavedCardList.vue?vue&type=template&id=2ab95cf0"
import script from "./SavedCardList.vue?vue&type=script&lang=js"
export * from "./SavedCardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__